import React from 'react';
import FEFabProps from './props';
import style from './style.module.css';

export default React.forwardRef<HTMLButtonElement, FEFabProps>(
  ({ children, onClick }, ref) => (
    <button
      ref={ref}
      className={style.root}
      onClick={(e) => {
        onClick(e);
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {children}
    </button>
  ),
);

export type { FEFabProps };
